import { Component, HostListener, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { CommonService } from "../services/common.service";

@Component({
  selector: "app-booking-confirmation",
  templateUrl: "./booking-confirmation.component.html",
  styleUrls: ["./booking-confirmation.component.scss"],
})
export class BookingConfirmationComponent implements OnInit {
  loading: boolean = false;
  isInquiry: boolean = false;
  appointmentType = null;
  bookingId = null;
  businessDetails = {
    businessName: null,
    businessLogo: null,
    confirmationText: null,
  };
  appointmentData = {
    bookingId: null,
    bookingDate: null,
    bookingTime: null,
    categoryName: null,
    personnelKey: null,
    personnelValue: null,
    name: null,
    phone: null,
    email: null,
  };
  slug = null;

  constructor(private router: Router, private commonService: CommonService) {}

  ngOnInit(): void {
    //set theme color here. Replace var with theme color.
    const primaryColor = sessionStorage.getItem("theme_color");
    this.commonService.newAppointmentData.themeColor = primaryColor;
    document.documentElement.style.setProperty("--custom-color", primaryColor);

    if (history.state.bookingId) {
      this.bookingId = history.state.bookingId;
    } else {
      this.bookingId = sessionStorage.getItem("bookingId");
    }
    if (!this.commonService.newAppointmentData.slug) {
      this.slug = sessionStorage.getItem("slug");
      this.commonService.newAppointmentData.slug = this.slug;
    }
    if (this.commonService.newAppointmentData.appointmentType == 1) {
      this.isInquiry = true;
      this.getInquiryDetailsById();
      this.appointmentType = 1;
    }
    if (this.commonService.newAppointmentData.appointmentType == 2) {
      this.isInquiry = false;
      this.appointmentType = 2;
      this.getBookingDetailsFromBookingId();
    }
    if (!this.bookingId) {
      // refreshed page
      this.navigateToMainPage();
    }
  }

  @HostListener("window:popstate", ["$event"])
  onPopState(event) {
    this.navigateToMainPage();
  }

  getBookingDetailsFromBookingId() {
    this.loading = true;
    this.commonService
      .getBookingDetailsFromId(this.bookingId)
      .subscribe((data: any) => {
        if (data.code === 200) {
          this.businessDetails.businessName = data.data.business_name;
          this.businessDetails.businessLogo = data.data.business_logo;
          if (data.data.appointment_settings.is_booking_confirmation_text) {
            this.businessDetails.confirmationText =
              data.data.appointment_settings.booking_confirmation_text;
          }
          if (data.data.appointment_settings.display_name) {
            this.appointmentData.personnelKey =
              data.data.appointment_settings.display_name;
          }

          let bookingDetails = data.data.appointments[0];
          if (bookingDetails) {
            this.appointmentData.bookingId = bookingDetails.appointment_id;
            this.appointmentData.bookingDate = bookingDetails.date;
            this.appointmentData.bookingTime = bookingDetails.slot_time;
            this.appointmentData.categoryName = bookingDetails.category_name;
            // this.appointmentData.email = bookingDetails.email_id;
            if (
              bookingDetails.tag_team_member_first_name ||
              bookingDetails.tag_team_member_last_name
            ) {
              this.appointmentData.personnelValue =
                bookingDetails.tag_team_member_first_name +
                bookingDetails.tag_team_member_last_name;
            }
          }

          this.loading = false;
          this.clearStorage();
        }
      });
  }

  getInquiryDetailsById() {
    this.loading = true;
    this.commonService
      .getInquiryDetailsFromId(this.bookingId)
      .subscribe((data: any) => {
        if (data.code === 200) {
          this.businessDetails.businessName = data.data.business_name;
          this.businessDetails.businessLogo = data.data.business_logo;

          if (data.data.appointment_settings.is_enquiry_confirmation_text) {
            this.businessDetails.confirmationText =
              data.data.appointment_settings.enquiry_confirmation_text;
          }
          if (data.data.appointment_settings.display_name) {
            this.appointmentData.personnelKey =
              data.data.appointment_settings.display_name;
          }

          let enquiry_details = data.data.enquiry_detail;
          if (enquiry_details) {
            this.appointmentData.bookingId = enquiry_details.enquiry_number;
            this.appointmentData.name = enquiry_details.name;
            this.appointmentData.phone = enquiry_details.phone_number;
            this.appointmentData.email = enquiry_details.email_id;
            this.appointmentData.categoryName = enquiry_details.category_name;
            if (
              enquiry_details.tag_team_member_first_name ||
              enquiry_details.tag_team_member_last_name
            ) {
              this.appointmentData.personnelValue =
                enquiry_details.tag_team_member_first_name +
                enquiry_details.tag_team_member_last_name;
            }
          }

          this.clearStorage();

          this.loading = false;
        }
      });
  }

  public clearStorage() {
    // clear Data
    // sessionStorage.removeItem("slug");
    sessionStorage.removeItem("bookingDetails");
    sessionStorage.removeItem("bookingId");
    // sessionStorage.removeItem("BookingData");
    // this.commonService.newAppointmentData.slug = null;
    this.commonService.newAppointmentData.headerData = null;
    this.commonService.newAppointmentData.categoryData = null;
    this.commonService.newAppointmentData.appointmentType = null;
  }

  public navigateToMainPage() {
    this.slug = this.commonService.newAppointmentData.slug;
    this.router.navigateByUrl(`/book/${this.slug}`);
  }

  public show12HrTime(time) {
    return this.commonService.format12HourTime(time);
  }
}
